import { getClosestPreferenceLevelValue } from "@/utils/PreferenceLevels";

const cloneDeep = value => JSON.parse(JSON.stringify(value));

export function getBulkFallbackPreferences({
  preferences = [],
  roomTypes = [],
  defaultPreferenceValue = 1
}) {
  if (Array.isArray(preferences) && preferences.length > 0) {
    return cloneDeep(preferences);
  }

  return roomTypes.map(name => {
    return {
      name,
      value: defaultPreferenceValue
    };
  });
}

export function buildBulkPreferences({
  sourcePreferences,
  roomTypes = [],
  fallbackPreferences = [],
  defaultPreferenceValue = 1
}) {
  const source =
    Array.isArray(sourcePreferences) && sourcePreferences.length > 0
      ? sourcePreferences
      : fallbackPreferences;

  const names =
    roomTypes.length > 0
      ? roomTypes
      : source.map(e => e.name);

  return names.map(name => {
    const found = source.find(e => e.name === name);
    const value = found ? Number(found.value) : defaultPreferenceValue;

    return {
      name,
      value: getClosestPreferenceLevelValue(value)
    };
  });
}

export function createBulkEditState({
  selectedClasses = [],
  classes = [],
  rooms = [],
  roomTypes = [],
  preferences = [],
  defaultPreferenceValue = 1
}) {
  if (selectedClasses.length === 0) {
    return null;
  }

  const firstSelected = selectedClasses[0];
  const firstClass = classes[firstSelected.idx] || {};
  const fallbackPreferences = getBulkFallbackPreferences({
    preferences,
    roomTypes,
    defaultPreferenceValue
  });

  return {
    dialog: true,
    applyPreferences: rooms.length > 0,
    applyPcd: false,
    pcd: Boolean(firstClass.pcd),
    preferences: buildBulkPreferences({
      sourcePreferences: firstClass.preferencias,
      roomTypes,
      fallbackPreferences,
      defaultPreferenceValue
    }),
    error: ""
  };
}

export function setBulkPreferenceValue({
  preferences = [],
  preferenceName,
  value
}) {
  return preferences.map(preference => {
    if (preference.name !== preferenceName) {
      return preference;
    }

    return {
      ...preference,
      value: Number(value)
    };
  });
}

export function applyBulkEditToClasses({
  classes = [],
  selectedClasses = [],
  bulkEdit,
  rooms = []
}) {
  if (selectedClasses.length === 0) {
    return {
      classes,
      updated: false,
      error: ""
    };
  }

  if (!bulkEdit.applyPreferences && !bulkEdit.applyPcd) {
    return {
      classes,
      updated: false,
      error: "Selecione ao menos um campo para atualizar."
    };
  }

  const selectedIndexes = new Set(selectedClasses.map(e => e.idx));

  const updatedClasses = classes.map((classItem, idx) => {
    if (!selectedIndexes.has(idx)) {
      return classItem;
    }

    const updatedClass = cloneDeep(classItem);

    if (bulkEdit.applyPreferences && rooms.length > 0) {
      updatedClass.preferencias = cloneDeep(bulkEdit.preferences);
    }

    if (bulkEdit.applyPcd) {
      updatedClass.pcd = bulkEdit.pcd;
    }

    return updatedClass;
  });

  return {
    classes: updatedClasses,
    updated: true,
    error: ""
  };
}